import { useState } from 'react';
import { getBackendDetails } from '@/utils/getBackendDetails';
import { useJWT } from './useAuth';

interface LogoutResponse {
  success: boolean;
}

export function useLogout() {
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { clearAccessToken } = useJWT();

  const logout = async () => {
    setIsLoading(true);
    setError(null);

    const { hostname, httpProtocol } = getBackendDetails();
    const logoutUrl = `${httpProtocol}://${hostname}/auth/logout`;

    try {
      const response = await fetch(logoutUrl, {
        method: 'POST',
        credentials: 'include', // Important for cookies
      });

      const data: LogoutResponse = await response.json();

      if (!response.ok) {
        throw new Error('Logout failed');
      }

      // Clear the access token
      clearAccessToken();

      return data;
    } catch (err) {
      setError(
        err instanceof Error ? err.message : 'An error occurred during logout',
      );
      // Clear token even if logout fails
      clearAccessToken();
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    logout,
    error,
    isLoading,
  };
}
